import * as React from 'react';
import { styles } from './styles';
import { Columns } from '@joykit';
import { Link } from 'react-router-dom';
import { telemetry } from '@services/tracking/telemetry';

interface Props {
  notMobile: boolean;
}

export class ShowcaseHeader extends React.PureComponent<Props> {
  render(): React.ReactNode {
    return (
      <div className={styles.headerContainer}>
        <Columns>
          <Columns.Column tablet={10} tabletOffset={1} desktop={6} desktopOffset={3}>
            <h1 className={styles.header}>Thousands of design combinations</h1>
            {this.props.notMobile ? (
              <p className={styles.subtitle}>
                Create the perfect look. Mix and match layouts, themes, fonts, colors, and photos to design your own
                wedding website template in minutes. You can change any part of your design at anytime.{' '}
                <Link
                  to="/preview"
                  aria-label="Start customizing your website design"
                  onClick={() => {
                    telemetry.sendEvent({
                      category: 'marketing.designs',
                      action: 'OpenCustomizer',
                      label: 'header_link'
                    });
                  }}
                >
                  Start customizing your website.
                </Link>
              </p>
            ) : (
              <p className={styles.subtitle}>
                Design your wedding website template in minutes. Mix and match layouts, themes, colors, and fonts at any
                time to customize your design.
              </p>
            )}
          </Columns.Column>
        </Columns>
      </div>
    );
  }
}
